import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  flex: 1,
  minWidth: 0,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'grey.300',
  borderRadius: 0.5,
  display: 'flex',
  flexDirection: 'column',
};

export const header: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  px: 1.5,
  py: 1.25,
};

export const headerDivider: SxStyle = {
  borderColor: 'grey.300',
};

export const content: SxStyle = {
  p: 1.5,
};

export const grid: SxStyle = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 345fr) minmax(0, 453fr)',
  columnGap: 2.5,
  rowGap: 2,
};

export const group: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

export const featureRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const checkmark: SxStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  borderRadius: '50%',
  bgcolor: 'primary.50',
  color: 'primary.main',
  flexShrink: 0,
};
